export function buildReturnState(location, returnLabel) {
  if (!location?.pathname) return {}
  const returnTo = `${location.pathname}${location.search || ''}${location.hash || ''}`
  return {
    returnTo,
    returnLabel,
  }
}

export function getSafeReturnTarget(state) {
  const rawReturnTo = typeof state?.returnTo === 'string' ? state.returnTo.trim() : ''
  const returnTo = rawReturnTo.startsWith('/') && !rawReturnTo.startsWith('//') ? rawReturnTo : ''
  const returnLabel = typeof state?.returnLabel === 'string' ? state.returnLabel.trim() : ''
  return {
    returnTo,
    returnLabel,
  }
}
